<template>
  <div class="footer">
    <div class="clearfix"></div>
    <el-collapse v-model="activeName">
      <el-collapse-item title="快捷通道" name="1">
        <a href="https://www.goldentec.com/solutions/cloud-ticket" target="_blank">云票儿电子发票</a>
        <a href="https://partner.wetax.com.cn/#/user/login" target="_blank">云票儿服务商平台</a>
        <a href="https://cloud.wetax.com.cn/" target="_blank">云票儿商家平台</a>
        <a href="https://www.goldentec.com/solutions/freeSalary" target="_blank">自由薪</a>
        <a href="https://www.goldentec.com/solutions/new-retail-partner" target="_blank">智慧零售门店合伙人</a>
        <a href="https://www.goldentec.com/openPlatform" target="_blank">云票儿开放平台</a>
        <a href="https://www.goldentec.com/solutions/yunpiaoer" target="_blank">云票儿</a>
        <a href="https://www.goldentec.com/solutions/etc" target="_blank">ETC助手</a>
        <a href="https://www.goldentec.com/solutions/kbb" target="_blank">快报报</a>
      </el-collapse-item>
      <el-collapse-item title="合作伙伴" name="2">
        <p>腾讯区块链</p>
        <p>腾讯金融科技</p>
        <p>中国注册会计师协会</p>
      </el-collapse-item>
      <el-collapse-item title="联系我们" name="3">
        <p>云票儿电子发票：4001272200转1</p>
        <p>高灯自由薪/高灯任务中心/微纳税：4001272200转2</p>
        <p>快商税：4001272200转4</p>
        <p>高灯云开放平台：4001272200转6</p>
        <p>高灯云企：4001272200转8</p>
        <p>ETC助手：4008291777</p>
        <p>快报报：4001172778</p>
      </el-collapse-item>
    </el-collapse>
    <div class="qr-hide-box" @click="handleShow">
      <img src="../assets/QR-code.png" alt="">
    </div>
    <div class="txt">
      <p>版权所有 ©深圳高灯计算机科技有限公司  琼ICP备18002958号-6
</p>
    </div>
    <div class="qr-code-wrap" @click="handleHide" @mousewheel.prevent @touchmove.prevent v-if="qrCodeVisible">
      <div class="qr-code">
        <img src="@/assets/QR-code.png">
        <p>长按识别二维码关注“高灯云”公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileFooter',
  data() {
    return {
      activeName: '3',
      qrCodeVisible: false
    }
  },
  methods: {
    handleShow() {
      this.qrCodeVisible = true
    },
    handleHide(e) {
      if (e.target.className === 'qr-code-wrap') {
        this.qrCodeVisible = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
@import "~@/styles/mixin.scss";

.footer {
  width: 100%;
  box-sizing: border-box;
  background: #212122;
  color: #fff;
  font-family: PingFangSC-Regular,PingFang SC;
  @include px2rem(padding-bottom, 53px);
  text-align: left;
  .clearfix {
    overflow: hidden;
  }
  .clearfix:after{
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  /deep/.el-collapse-item__header{
    background: #212122;
    border-bottom: 1px solid #363637;
    color: #fff;
    @include px2rem(padding-left, 30px);
  }
  :global(.el-collapse-item__wrap) {
    background: #212122;
    border-bottom: 1px solid #363637;
    /deep/.el-collapse-item__content{
      background: #212122;
      padding-bottom: 0;
      a,p{
        display: block;
        color: #ccc;
        @include px2rem(margin, 40px 30px);
      }
    }
  }
  .qr-hide-box{
    width: 120px;
    height: 120px;
    background: #fff;
    border-radius: 2px;
    color: #fff;
    @include px2rem(margin, 50px 0 161px 30px);
    img{
      width: 120px;
    }
    p{
      margin-top: 12px;
      text-align: center;
    }
  }
  .txt{
    text-align: center;
    p{
      @include px2rem(font-size, 20px);
      @include px2rem(line-height, 20px);
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
  }
}
.el-collapse {
  border-top: 0;
}
/deep/.el-collapse-item__arrow.el-icon-arrow-right{
  transform: rotate(90deg);
}
/deep/.el-collapse-item__arrow.el-icon-arrow-right.is-active{
  transform: rotate(270deg);
}
.qr-code-wrap{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  z-index: 1000;
  .qr-code{
    position: fixed;
    left: 50%;
    top: 50%;
    @include px2rem(margin-top, -266px);
    @include px2rem(margin-left, -266px);
    @include px2rem(width, 532px);
    @include px2rem(height, 532px);
    text-align: center;
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, .1);
    background: #FFFFFF;
    @include px2rem(width, 532px);
    z-index: 1001;
    animation: scale 0.5s;
    -moz-animation: scale 0.5s;
    -webkit-animation: scale 0.5s;
    -o-animation: scale 0.5s;
    img{
        width: 100%;
    }
    p{
      color: #FFF;
      @include px2rem(margin-top, 40px);
      @include px2rem(font-size, 26px);
      @include px2rem(line-height, 37px);
      font-weight: 500;
    }
  }
}
@keyframes scale
{
  0% {transform:scale(0);}
  100% {transform:scale(1);}
}

@-moz-keyframes scale
{
  0% {transform:scale(0);}
  100% {transform:scale(1);}
}

@-webkit-keyframes scale
{
  0% {transform:scale(0);}
  100% {transform:scale(1);}
}

@-o-keyframes scale
{
  0% {transform:scale(0);}
  100% {transform:scale(1);}
}
</style>
